var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEvent = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 31.982,
    viewBox: "0 0 32 31.982",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.009 -0.009)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(31.991 -0.009) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27,32H5.016a5,5,0,0,1-5-5V5a5.01,5.01,0,0,1,5-5h6a1,1,0,0,1,0,2h-6a3.007,3.007,0,0,0-3,3V27a3,3,0,0,0,3,3H27a3.008,3.008,0,0,0,3-3V26a1,1,0,0,1,2,0v1A5.011,5.011,0,0,1,27,32Z",
    transform: "translate(0)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2142.533,6558.342a1,1,0,0,1-.65-.241l-6.438-5.519a1,1,0,0,1,0-1.519l6.438-5.519a1,1,0,1,1,1.3,1.519l-5.552,4.759,5.552,4.759a1,1,0,0,1-.651,1.759Z",
    transform: "translate(-6529.82 2162.42) rotate(-90)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2136.1,6558.342a1,1,0,0,1-.651-1.759l5.552-4.759-5.552-4.759a1,1,0,0,1,1.3-1.519l6.438,5.519a1,1,0,0,1,0,1.519l-6.438,5.519A1,1,0,0,1,2136.1,6558.342Z",
    transform: "translate(-6529.82 2144.025) rotate(-90)",
    fill: "current"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2145.127,6559.507a1,1,0,0,1-.93-1.368l5.307-13.434a1,1,0,0,1,1.86.735l-5.307,13.434A1,1,0,0,1,2145.127,6559.507Z",
    transform: "translate(-6529.616 2161.677) rotate(-90)",
    fill: "current"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEvent, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/event.dc2271c8.svg";
export { ForwardRef as ReactComponent };